import type {
  BreakpointColumnConfig,
  BreakpointRowConfig,
  BreakpointCellConfig,
  BreakpointWidthConfig,
} from "../types";
import { DEFAULT_PADDING, DEFAULT_BORDER } from "./styleUtils";

// ============================================
// DEFAULT CONFIGURATIONS
// ============================================

export const DEFAULT_BREAKPOINT_WIDTH: BreakpointWidthConfig = { 
  type: "percent" as const, 
  value: "100", 
  alignment: "left" as const, 
  horizontalScroll: false,
  rowGap: 0,
};

export const createDefaultColumnConfig = (): BreakpointColumnConfig => ({
  widthType: "percent",
  widthValue: "33",
  textAlign: "left",
  verticalAlign: "middle",
  padding: { ...DEFAULT_PADDING },
});

export const createDefaultRowConfig = (): BreakpointRowConfig => ({
  heightType: "auto",
  heightValue: "",
  backgroundColor: "",
  textColor: "",
});

export const createDefaultCellConfig = (): BreakpointCellConfig => ({
  backgroundColor: "",
  textColor: "",
  border: { ...DEFAULT_BORDER },
  textAlign: "left",
  verticalAlign: "middle",
  padding: { ...DEFAULT_PADDING },
  fontSize: "",
  fontWeight: "",
});

// ============================================
// COMPACT KEY MAPPINGS for efficient storage
// ============================================

// Table Settings compact keys
export const TABLE_SETTINGS_KEYS: Record<string, string> = {
  tableWidths: 'tw',
  tableBorderColor: 'tbc',
  tableBorderWidth: 'tbw',
  tableBorderRadius: 'tbr',
  tableRowGap: 'trg',
};

// Breakpoint Width compact keys
export const BREAKPOINT_WIDTH_KEYS: Record<string, string> = {
  type: 't',
  value: 'v',
  alignment: 'a',
  horizontalScroll: 'hs',
  rowGap: 'rg',
};

// Column Settings compact keys
export const COLUMN_SETTINGS_KEYS: Record<string, string> = {
  columnIndex: 'ci',
  styles: 's',
  widthType: 'wt',
  widthValue: 'wv',
  textAlign: 'ta',
  verticalAlign: 'va',
  padding: 'p',
  border: 'bd',
};

// Row Settings compact keys
export const ROW_SETTINGS_KEYS: Record<string, string> = {
  rowIndex: 'ri',
  styles: 's',
  heightType: 'ht',
  heightValue: 'hv',
  backgroundColor: 'bg',
  textColor: 'c',
};

